function isDevelopment () {
    return process.env.NODE_ENV === 'development'
}

export { isDevelopment }



// WEBPACK FOOTER //
// ./client/lib/App.js